const KEY = "shakthi_utm";
const FIELDS = ["utm_source", "utm_medium", "utm_campaign"];

export function captureUtm() {
  try {
    const params = new URLSearchParams(window.location.search);
    const found = {};
    FIELDS.forEach(k => { const v = (params.get(k) || "").trim(); if (v) found[k] = v.slice(0, 100); });
    if (Object.keys(found).length) sessionStorage.setItem(KEY, JSON.stringify(found));
  } catch (e) { /* storage unavailable */ }
}

export function getUtm() {
  captureUtm();
  try {
    return JSON.parse(sessionStorage.getItem(KEY) || "{}");
  } catch (e) {
    return {};
  }
}
